/* the idea is to create separate theme objects for light and dark schema, and inject it separatlly if using a module
so, maybe there need to be some extra listeners and watchers for scheme building.
Question is, when the schema object is used inside makeStyles? Suspision, as function, it is used when component is
created , or bring to life is application cycle
 */

export const documentViewerPalette = {
    light: {
        pageSelectedBackgroundColor: '#e3e3e3',
        buttonsBackgroundColor: '#afafaf',
        buttonsGroupBackgroundColor: '#bababa',
        selectedInGroupBackgroundColor: '#1C1B1F',
        selectedInGroupColor: '#FFFFFF',
        thumbnailBorderColor: '#E2E8F0',
        thumbnailBlockBackgroundColor: '#E2E8F0',
        thumbnailBlockBorderColor: '#C8D7EA',
        spellContainerBackgroundColor: '#a8a8a8',
        contrastTextColor: '#101010',
        lowContrastTextColor: '#424242',
        lowContrastText2Color: '#1a1a1b',
        lowContrastText3Color: '#4f4f4f',
        lowContrastText4Color: '#87a3d8',
        spellContainerGroupBackgroundColor: '#f6f6f6',
        timelineItemBackgroundColor: '#9e9fa5',
        lowContrastTextHoverColor: '#262729',
        thumbnailGray: '#64748B',
        thumbnailBackPageBackgroundColor: '#efefef',
        thumbnailBackPageBorderColor: '#474747',
        thumbnailPagesIcon: 'rgba(0, 0, 0, 0.92)',
        timelineBorderColor: '#626466',
        tabIconDefaultColor: '#7986cb',
        tabBackgroundColor: '#cccccc',
        tabSelectedBackgroundColor: '#2180F7',
        toolPanelBackground: '#e8e8e8',
        cursorIconBackgroundColor: 'rgba(26, 26, 26, 0.64)',
        paperBackgroundColor: 'rgb(183, 183, 183, 0.85)',
        uploadModalWarningBackground: 'rgb(255, 245, 229, 0.9)',
        uploadModalWarningColor: '#f6a850',
        traficLightRed: '#E25B61',
    },
    dark: {
        pageSelectedBackgroundColor: '#000000',
        buttonsBackgroundColor: '#494B4C',
        buttonsGroupBackgroundColor: '#3D3E40',
        selectedInGroupBackgroundColor: '#FFFFFF',
        selectedInGroupColor: '#1C1B1F',
        thumbnailBorderColor: '#171E29',
        thumbnailBlockBackgroundColor: '#171E29',
        thumbnailBlockBorderColor: '#334155',
        spellContainerBackgroundColor: '#626466',
        contrastTextColor: '#FFFFFF',
        lowContrastTextColor: '#ACAFB3',
        lowContrastText2Color: '#313233',
        lowContrastText3Color: '#f0f0f0',
        lowContrastText4Color: '#f5f5f5',
        spellContainerGroupBackgroundColor: '#222425',
        timelineItemBackgroundColor: '#3D3E40',
        lowContrastTextHoverColor: '#6F7173',
        thumbnailGray: '#64748B',
        thumbnailBackPageBackgroundColor: '#f8f8f8',
        thumbnailBackPageBorderColor: '#909090',
        thumbnailPagesIcon: 'rgba(0, 0, 0, 0.92)',
        timelineBorderColor: '#626466',
        tabIconDefaultColor: '#2280f7',
        tabBackgroundColor: '#313233',
        tabSelectedBackgroundColor: '#2180F7',
        toolPanelBackground: '#252525',
        cursorIconBackgroundColor: 'rgba(172, 171, 171, 0.64)',
        paperBackgroundColor: 'rgba(0,0,0, 0.95)',
        uploadModalWarningBackground: '#FEE4B1',
        uploadModalWarningColor: '#804501',
        traficLightRed: '#E25B61',
    },
};
